// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import './style.css';

function TableHeader (props) {
    const [tableHeaderSample] = useState({});
    // const [admin_type,setAdminType]= useState(null)
    // useEffect(() => {
    //     if (user_Status === 1) {
    //         setAdminType(UserData.login_Auth_Res.access_level);
    //         // adminData = this.state.adminType === 'location_admin' ? "Location Name" : null;
    //     }
    //   });
    // This method is for rendering Column header names
    
    let display_length;
    if (props.displayed_list_length === props.total_list_length) {
        display_length = "("+props.displayed_list_length+")";
    } else {
        let tmp_from = props.from + 1;
        let tmp_to = props.from + props.limit;
        if (tmp_to > props.total_list_length) {
            tmp_to = props.total_list_length;
        }
        display_length = "("+tmp_from+" - "+tmp_to+" / "+props.total_list_length+")";
    }

    let total_pagination_pages = Math.ceil(props.total_list_length / props.limit);

    let pagination_pages = [];
    
    if (total_pagination_pages > 10) {
        // use dropdown
        let dropdown_items = [];
        for (let i = 0; i < total_pagination_pages; i++) {
            dropdown_items.push(
                <Dropdown.Item
                    key={i}
                    onClick={() => OnPaginate(i+1)}
                >
                    Page {i+1}
                </Dropdown.Item>            
            );
        }
        let dropdown_element =
            <DropdownButton
                key="page_dropdown"
                title={'Page '+props.current_page_number}
                style={{ display: "inline" }}
                size="sm"
                drop="left"
            >
            {dropdown_items}
            </DropdownButton>;
        
        pagination_pages[0] = dropdown_element;
    
    } else if (total_pagination_pages > 1) {
        for (let i = 0; i < total_pagination_pages; i++) {
            let tmp_color = props.theme === 'dark' ? 'white' : 'black';
            if (i+1 === props.current_page_number) {
                tmp_color = "#E50114";
            }
            pagination_pages.push(
                <span
                    style= {{ color: tmp_color, cursor: "pointer", paddingLeft: "5px", paddingRight: "5px" }}
                    key={i}
                    onClick={() => OnPaginate(i+1)}
                >
                    {i+1}
                </span>
            );
        }
    }

    /*    
    // if too many pages...show first 3, middle 3, and last 3
    if (pagination_pages.length > 10) {

        let middle_index = Math.floor(pagination_pages.length / 2);
        let beginning_pages = pagination_pages.slice(0,3);
        let middle_pages = pagination_pages.slice(middle_index-1,middle_index+2);
        let end_pages = pagination_pages.slice(-3);
        
        let dots_span_first =
            <span
                style={{ paddingLeft: "5px", paddingRight: "5px" }}
                key="first_dots"
            >
            ..
            </span>;
        let dots_span_second =
            <span
                style={{ paddingLeft: "5px", paddingRight: "5px" }}
                key="second_dots"
            >
            ..
            </span>;

        pagination_pages = beginning_pages.concat([dots_span_first],middle_pages,[dots_span_second],end_pages);
    }
    */
    
    
    let header_title;
    if (props.from === 0 && props.displayed_list_length === props.total_list_length) {
        header_title = "All";
    } else {
        header_title = "Page "+props.current_page_number;
    }
    
    function OnPaginate (page_number) {
        console.log("OnPaginate",page_number);
        if (props.OnPaginateCallback && page_number >= 1 && page_number <= total_pagination_pages) {
            props.OnPaginateCallback(page_number);
        }
    }
    
    function renderTableHeader() {
        let header = props.tableHeader ? Object.keys(props.tableHeader) : Object.keys(tableHeaderSample);
        return header.map((key, index) => {
            if(props.headerStatus===false){
                if(key === "location_admin")
                {
                    key=props.admin_type && "Location Name" ;
                }
                else if(key === "channel_admin"){
                    key=props.admin_type && "Channel Name";
                }
                else if(key === "admin"){
                    key=props.admin_type && "Location / Channel Name";
                }
            }
            if (index >= header.length - 1) {
                return (
                    <th style={{ textAlign: "right" }} key={index}>{key.toUpperCase()}</th>
                );
            } else {
                return (
                    <th key={index}>{key.toUpperCase()}</th>
                );
            }
        });
    }

    return (
        <React.Fragment>
            <tr className="">
                <th className="table-caption" colSpan={Object.keys(props.tableHeader).length}>
                    <div className="draftsData">
                        <h4 style={{ display: "inline" }}>{header_title}&nbsp;<span>{display_length}</span></h4>
                        { pagination_pages.length > 0 &&
                            <div style={{ whiteSpace: "nowrap", float: "right", display: "inline" }}>
                                <span
                                    style={{ display: "inline", cursor: "pointer" }}
                                    onClick={() => OnPaginate(props.current_page_number-1)}
                                >
                                    <i className="fa fa-angle-left breadcrumb-angle" aria-hidden="true"></i>
                                </span>
         
                                {
                                    pagination_pages.map(item => item)
                                }
         
                                <span
                                    style={{ display: "inline", cursor: "pointer" }}
                                    onClick={() => OnPaginate(props.current_page_number+1)}
                                >
                                    <i className="fa fa-angle-right breadcrumb-angle" aria-hidden="true"></i>
                                </span>
                            </div>
                        }
                    </div>
                </th>
            </tr>
            <tr className="thead">{renderTableHeader()}</tr>
        </React.Fragment>
    )
}
export default TableHeader;




